<template>

    <transition name="fade">
        <div>
            <bar-manut 
                single-entity="Importação de Produtos" 
                :disableSave="true"
                @closeform="handleVoltar" >
            </bar-manut>

            <div class="default-container" v-if="estagio == 'inicio'">
                <label-title title="Planilha Modelo" class="mb-2"></label-title>
                <hr>
                <div class="row">
                    <div class="col-md-12">
                        <span class="w-100 lbl">Efetue o download da planilha modelo.</span>
                        <span class="w-100 lbl">Preencha as colunas da planilha com os dados dos produtos a serem importados, respeitando a ordem das colunas.</span>
                        <span class="w-100 lbl">A importação não será realizada caso a planilha esteja em formato diferente da planilha de modelo.</span>
                    </div>
                    <div class="col-md-12 mt-2">
                        <!-- <button type="button" class="cert-button" @click="handleAtivarExtensao()">Instalar Agora</button> -->
                        <v-button label="Download da planilha modelo" icon="fa-download" @click="handleDownloadModelo()"></v-button>
                    </div>
                </div>
                <label-title title="Selecionar Arquivo Para Importação" class="mt-5"></label-title>
                <hr>
                <div class="row" style="padding-bottom: 100px">
                    <div class="col-md-12">
                        <span class="w-100 lbl">Selecione o arquivo a ser importado.</span>
                        <span class="w-100 lbl">Os produtos da planilha inexistentes no sistema serão inseridos. Os demais serão atualizados.</span>
                    </div>
                    <div class="col-md-12 mt-2">
                        <v-button label="Selecionar Arquivo" :nb-btdef="false" icon="fa-upload" @click="handleSelecionarArquivo()"></v-button>
                        {{ selectedFile.name }}
                        <div v-show="false">
                            <input type="file" ref="file" accept=".csv" @change="handleFileChange()">
                        </div>
                    </div>
                    <div class="col-md-12 mt-2">
                        <alert v-if="errmessage" type="warning" title="Erro na importação do arquivo" :text="errmessage"></alert>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-12 mt-2">
                        <v-button label="Continuar" :nb-btdef="true" @click="handleAnalisarArquivo()"></v-button>
                        <v-button label="Cancelar" @click="handleVoltar()"></v-button>
                    </div>
                </div>
            </div>


            <div class="default-container" v-if="estagio == 'showresumo'">
                <label-title title="Resumo da Importação" class="mb-2"></label-title>
                <hr>
                <div class="row" style="padding-bottom: 100px">
                    <div class="col-md-12">
                        <span class="lbl"> <strong>{{ dadosResumo.novos }}</strong> </span>
                        <span class="lbl"> produtos serão inseridos. </span>
                            <a style="cursor: pointer; color: #0091ea;" @click="handleExportaResumo('novo')">Visualizar</a>
                    </div>
                    <div class="col-md-12">
                        <span class="lbl"> <strong>{{ dadosResumo.alterados }}</strong> </span>
                        <span class="lbl"> produtos serão atualizados. </span>
                            <a style="cursor: pointer; color: #0091ea;" @click="handleExportaResumo('alterar')">Visualizar</a>
                    </div>
                    <div class="col-md-12">
                        <span class="lbl"> <strong>{{ dadosResumo.naoimportados }}</strong> </span>
                        <span class="lbl"> não serão importados. </span>
                            <a style="cursor: pointer; color: #0091ea;" @click="handleExportaResumo('naoimportado')">Visualizar</a>
                    </div>
                    <div class="col-md-12 mt-2">
                        <alert type="warning" title="Confirmar Importação" text="A importação ainda não foi efetuada. Confirme para efetivar."></alert>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-12 mt-2">
                        <v-button v-if="dadosResumo.novos == 0 && dadosResumo.alterados == 0" label="Selecionar Outro Arquivo" :nb-btdef="true" @click="handleSelecionarOutro()"></v-button>
                        <v-button v-if="dadosResumo.novos > 0 || dadosResumo.alterados > 0" label="Confirmar Importação" :nb-btdef="true" @click="handleConfirmarImportacao()"></v-button>
                        <v-button label="Cancelar" @click="handleVoltar()"></v-button>
                    </div>
                </div>
            </div>
        </div>


    </transition>

</template>

<script>

import { SysVars } from '../main'
import { formatDate, formatValue } from '../shared/utils'
import axios from 'axios'
import { apiORDS, apiORDSpost, urlORDS } from '../shared/api-functions'
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'

export default {
    props: {
        filial: {},
    },

    data() {
        return {
            estagio: 'inicio',
            errmessage: '',
            selectedFile: {},
            urlFile: '',
            url: urlORDS(this.$store, 'cg/importa/produtos'),
            prepara: false,

            dadosResumo: {},
            csv: null,
        }
    },

    computed: {
        status: function () {
            return ''
        }
    },

    methods: {
        handleVoltar () {
            this.$router.go(-1)
        },

        handleDownloadModelo() {
            window.open('https://novo.notabrasil.com.br/planilha_modelo_produto.csv', "_blank")
        },

        handleFileChange () {
            this.selectedFile = this.$refs.file.files[0]
        },

        handleAnalisarArquivo(){
            //ENVIA O ARQUIVO PARA ANALISE DA IMPORTACAO
            if (!this.selectedFile)
              return

            var extPermitidas = ['csv'];
            let self = this
            
            if(typeof extPermitidas.find(function(ext){ return self.selectedFile.name.split('.').pop() == ext; }) == 'undefined') {
                self.$erpToastError('Extensão do arquivo inválida! Somente arquivos ".csv" são permitidos.');
                return
            }


            this.prepara = true


            let reader = new FileReader()
            reader.readAsText(this.selectedFile, 'ISO-8859-1')
            reader.onload = function (event) {
                self.csv = event.target.result
                self.apiUpload()
                // console.log(csv)
            }
            reader.onerror = function (event) {
                if (event.target.error.name == 'NotReadableError') {
                    self.$erpToastError('Não foi possível ler o arquivo!')
                }
            }
            return
        },

        handleSelecionarOutro () {
            this.estagio = 'inicio'
            this.selectedFile = {}
        },

        handleConfirmarImportacao(){
            //ENVIA NOVAMENTE O MESMO ARQUIVO PARA IMPORTACAO
            this.prepara = false
            this.apiUpload()
        },

        apiUpload() {
            //EFETUA O UPLOAD DO ARQUIVO

            let formData = new FormData();
            formData.append('file.csv', new Blob([this.csv]), { type: 'text/csv' })

            var self = this

            this.message = null

            this.$appLoading(true)

            axios.post(this.url, formData,
                { 
                headers: {
//                    'Content-Type': 'multipart/form-data;charset=ISO-8859-1;', //'application/x-www-form-urlencoded;charset=UTF-8', //'multipart/form-data;',
                    'prepara': self.prepara,
                }
            }
            ).then(function(data){
                    if (data.data) {
                        self.dadosResumo = data.data
                        if (self.prepara)
                          self.estagio = 'showresumo'
                        else
                          self.handleVoltar()
                    }
                    self.$appLoading(false)
                })
                .catch(function(data){
                    self.$appLoading(false)
                    self.errmessage = data.message
                    self.$erpToastError('Erro ao carregar o arquivo')
                })
        },

        handleSelecionarArquivo() {
            //BOTAO SELECIONAR ARQUIVO
            this.$refs.file.click()
        },

        handleExportaResumo(tipo) {
            const data = this.dadosResumo.itens
              .filter((it) => it.status == tipo) 
              .map(it => {

                let obj = {
                            codigo: it.codigo,
                            descricao: it.descricao,
                            uni: it.uni,
                            custo: formatValue(it.custo,2),
                            precoVenda: formatValue(it.precovenda,2),
                            ipi: formatValue(it.aipi,2),
                }

                if (it.message)
                  obj.mensagem = it.message

                return obj
            })
            if (!data || data.length == 0)
              this.$erpToastError('Nenhum produto para visualizar')
            else {
                const csv = objectToCsv(data)
                downloadCsvReport(csv)
            }
        }

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })
        this.selectedFile = {}  
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/item-importa-form.vue